/* --------------------------------------------------------------------------------------
   privacyStatements.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const privacyStatementEnComponent  = {
    template: require('./privacyStatementEn.html')
}

export const privacyStatementFrComponent  = {
    template: require('./privacyStatementFr.html')
}

export const privacyStatementEsComponent  = {
    template: require('./privacyStatementEs.html')
}



// WEBPACK FOOTER //
// ./src/app/auth/components/privacyStatements.component.js